import { dateFormat, SIZE } from '@app/constants'

import type { LntDatePickerProps } from '@app/components/base/Form/Input/DatePicker/types'
import type { CommonScheduleData } from '@app/pages/MonitoringLaunchPage/types'
import type { CommonColumnsScheduleData } from './types'

export const datePickerPropsConfig: Record<keyof CommonColumnsScheduleData, LntDatePickerProps> = {
  startAt: { format: dateFormat.DD_MM_YYYY, size: SIZE.small },
  gettingDateAt: { format: dateFormat.DD_MM_YYYY_HH_mm, showTime: { format: dateFormat.HH_mm }, size: SIZE.small },
  processingDateAt: { format: dateFormat.DD_MM_YYYY_HH_mm, showTime: { format: dateFormat.HH_mm }, size: SIZE.small },
  dateDeadline: { format: dateFormat.DD_MM_YYYY_HH_mm, showTime: { format: dateFormat.HH_mm }, size: SIZE.small }
} as const

export const columnKeyToApiMap: Record<keyof CommonColumnsScheduleData, keyof CommonScheduleData> = {
  startAt: 'monitoringStartAtDatetime',
  gettingDateAt: 'receivingDataDeadlineDatetime',
  processingDateAt: 'processingDataDeadlineDatetime',
  dateDeadline: 'newDataDeadlineDatetime'
} as const
